import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NoNavigationHeaderComponent } from '../no-navigation-header/no-navigation-header.component';

@Component({
    imports: [NoNavigationHeaderComponent, RouterOutlet],
    selector: 'rdx-no-navigation-layout',
    standalone: true,
    templateUrl: './no-navigation-layout.component.html',
})
// This class intentionally empty
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class NoNavigationLayoutComponent {}
